const layout = () => import("../../external/layout.vue");
const authLabet = () => import("./adminLabet.vue");

const authLabetRoutes = {
  path: "/adminLabet",
  component: layout,
  children: [
    {
      path: "",
      name: "Admin Labet",
      component: authLabet,
    },
  ],
};

export default authLabetRoutes;
